import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SysConfigService } from './sys-config.service';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class SystemUserService {
  private BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';

  constructor(private http: HttpClient, private appConfig: AppConfig) {
  }

  /**
   * getAllSystemUsers
   */
  public getAllSystemUsers(): Observable<Array<string>> {
    return this.http.get<Array<string>>(this.BASE_URL + 'systemUsers/all');
  }
}
